import React, { useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import { SettingsState } from '../../../organisms/SelectSettings';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';
import { ItemComboBox, ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';

import { useModal } from '../../../../function/useModal';
import { ErrorCode } from '../../../../ErrorCode';

import { TableBaseStyle } from './PartialDischargeCollectionStyle';
import {
    GetPartialDischargeCollectionData
    , PutPartialDischargeCollectionData
    , SET_PART_DIS
} from './PartialDischargeCollection';
import PartialDischargeCollectionBody from './PartialDischargeCollectionBody';
import PartialDischargeCollectionFooter from './PartialDischargeCollectionFooter';


/**
 * タブ切替
 */
type PartialDischargeCollectionPageProps = {
    editData: SettingsState;
};

type SaveParameter = {
    list: SET_PART_DIS[];
};

const PartialDischargeCollectionPage: React.FC<PartialDischargeCollectionPageProps> = (props: PartialDischargeCollectionPageProps) => {
    const { t } = useTranslation();
    const pageStyle = TableBaseStyle();

    const [setPartDisList, setSetPartDisList] = useState<SET_PART_DIS[]>([]);
    const [nameDevSetComboBoxItemList, setNameDevSetComboBoxItemList] = useState<ComboBoxItemType[]>([]);
    const [mclcTypIdMaxComboBoxItemList, setMclcTypIdMaxComboBoxItemList] = useState<ComboBoxItemType[]>([]);
    const [mclcTypIdPdComboBoxItemList, setMclcTypIdPdComboBoxItemList] = useState<ComboBoxItemType[]>([]);
    const [buttonEnable, setButtonEnable] = useState<boolean>(true);
    const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
    const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
    const [dlgmsg, setDlgmsg] = useState<string>('');
    //部分放電画面有効フラグ
    const [partialDischargeIpEnabled, setPartialDischargeIpEnabled] = useState<boolean>(true);

    const cfmdlg = flgCfmDlg ? (
        <ConfirmDialog
            dialog={actCfmDlg}
            message={dlgmsg}
            action={t('PartialDischargeCollectionPage.はい', 'はい')}
            cancel={t('PartialDischargeCollectionPage.いいえ', 'いいえ')}
        />
    ) : null;

    const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

    /**
      * 初期表示
      */
    useEffect(() => {
        console.debug(['useEffect init', props]);
        updateData();
    }, []);

    /**
     * 
     */
    useEffect(() => {
        props.editData.SaveFunction = saveAction2;
        props.editData.IsUpdate = false;
    }, [props.editData.CancelCondition]);

    /**
     * 画面更新
     */
    const updateData = () => {
        setButtonEnable(false);
        let setPartDisDataList: SET_PART_DIS[] = [];
        console.debug(["update start"]);
        //部分放電一覧の取得
        GetPartialDischargeCollectionData()
            .then((res) => {
                console.debug(['--partialDischargeCollectionModel--', res]);
                setPartDisDataList = res.PartialDischargeCollectionItems;
                setPartDisDataList.forEach((r) => {
                    r.isEdit = false;
                })
                setSetPartDisList(setPartDisDataList);
                //機器番号・名称 ComboBox取得
                setNameDevSetComboBoxItemList(
                    res.NameDevSetLists.map<ComboBoxItemType>((ci) => {
                        return { index: ci.Key, name: ci.Disp };
                    })
                );
                //部分放電判定_最大値異常内容 ComboBox取得
                setMclcTypIdMaxComboBoxItemList(
                    res.MclcTypIdMaxDataList.map<ComboBoxItemType>((ci) => {
                        return { index: ci.Key, name: ci.Disp };
                    })
                );
                //部分放電判定_PD強度異常内容 ComboBox取得
                setMclcTypIdPdComboBoxItemList(
                    res.MclcTypIdPdDataList.map<ComboBoxItemType>((ci) => {
                        return { index: ci.Key, name: ci.Disp };
                    })
                );
                if (res.PartialDischargeCollectionType !== 0) {
                    setPartialDischargeIpEnabled(false);
                }
                setButtonEnable(false);
            }).catch(e => {
                setDlgmsg(t('PartialDischargeCollectionPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
                actMsgDlg.open();
                console.debug(["e", e]);
                setButtonEnable(false);
            }).finally(() => {
                //setButtonEnable(true);
                console.debug(["update end"]);
            });
        props.editData.Target = { list: setPartDisList }
        props.editData.IsUpdate = false;
    };

    /**
     * 行変更通知
     * @returns
     */
    const changeSetPartDis = (target: SET_PART_DIS) => {
        console.debug(['ChangeSetPartDis - start', setPartDisList, target]);
        setSetPartDisList(
            setPartDisList.map((r) => (r.SET_NO === target.SET_NO) ? target : r)
        )
        props.editData.Target = { list: setPartDisList }
        props.editData.IsUpdate = true;
        setButtonEnable(true);
    };

    /**
     * 保存アクション
     * @returns 
     */
    const saveAction = () => {
        if (props.editData.IsUpdate === false) {
            return;
        }
        let changeSetPartDisList: SET_PART_DIS[] = [];
        changeSetPartDisList = setPartDisList.filter((r) => r.isEdit == true);
        changeSetPartDisList.forEach((r) => {
            if (r.DEV_INDEX == 0) {
                r.RUN_FLG = undefined;
                r.LOG_START = undefined;
                r.ITM_NAME_NO = undefined;
                r.LMT_L = undefined;
                r.LMT_H = undefined;
                r.MCLC_TYP_ID_MAX = undefined;
                r.TYP_NO_MAX = undefined;
                r.LMT_L_PD = undefined;
                r.LMT_H_PD = undefined;
                r.MCLC_TYP_ID_PD = undefined;
                r.TYP_NO_PD = undefined;
                r.IP_ADR = undefined;
            }
        });
        setDlgmsg(t('PartialDischargeCollectionPage.設定内容を保存しますか', '設定内容を保存しますか？'));
        actCfmDlg
            .open()
            .apply((_) => {

                saveProc(changeSetPartDisList).finally(() => {
                    setButtonEnable(false);
                });
            })
            .cancel(() => {
                console.debug(t('PartialDischargeCollectionPage.キャンセル', 'キャンセル'));
            });
    };

    /**
    * 保存処理
    */
    const saveProc = (target: object): Promise<string> => {
        return new Promise((resolve, reject) => {
            const setPartDis = target as SET_PART_DIS[];
            if (setPartDis) {
                PutPartialDischargeCollectionData(setPartDis)
                    .then((res) => {
                        console.debug(`setSetPartDisList res : ${res}`);
                        if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NONE) {
                            setDlgmsg(t('PartialDischargeCollectionPage.保存が正常に終了しました', '保存が正常に終了しました'));
                            actMsgDlg.open();
                            props.editData.IsUpdate = false;
                            updateData();
                            console.debug('saveAction ok');
                            resolve('done');
                        }
                        else {
                            if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_DEV_INDEX_DUPLICATION) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.機器番号_名称_重複', '(機器番号・名称:重複)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NODATE) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.収集開始時刻_必須項目', '(収集開始時刻:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NOLIML_VALUE) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_しきい値_軽故障_必須項目', '(部分放電判定 しきい値 軽故障:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NOLIMH_VALUE) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_しきい値_重故障_必須項目', '(部分放電判定 しきい値 重故障:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NOLIMLPD_VALUE) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_PD強度しきい値_軽故障_必須項目', '(部分放電判定 PD強度しきい値 軽故障:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NOLIMHPD_VALUE) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_PD強度しきい値_重故障_必須項目', '(部分放電判定 PD強度しきい値 重故障:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_LIM_VALUE) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_しきい値_軽故障_重故障', '(部分放電判定 しきい値 軽故障 < 重故障)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_LIMPD_VALUE) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_PD強度しきい値_軽故障_重故障', '(部分放電判定 PD強度しきい値 軽故障 < 重故障)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NOMCLC_TYP_ID_MAX) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_最大値異常内容No_必須項目', '(部分放電判定 最大値異常内容No:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NOMCLC_TYP_ID_PD) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.部分放電判定_PD強度異常内容No_必須項目', '(部分放電判定 PD強度異常内容No:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NOIPADR && partialDischargeIpEnabled === true) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.IPアドレス_必須項目', '(IPアドレス:必須項目)')
                                );
                                actMsgDlg.open();
                            }
                            else if (res.ResponceData.ErrorCode === ErrorCode.ERR_CODE_IPADR_INCORRECT && partialDischargeIpEnabled === true) {
                                setDlgmsg(t('PartialDischargeCollectionPage.設定内容が不正です', '設定内容が不正です。')
                                    + `\nNo.${res.ErrorSetNo}: `
                                    + t('PartialDischargeCollectionPage.IPアドレス_書式不正', '(IPアドレス:書式不正)')
                                );
                                actMsgDlg.open();
                            }
                            setButtonEnable(true);
                        }
                    })
                    .catch((error) => {
                        setDlgmsg(t('PartialDischargeCollectionPage.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
                        actMsgDlg.open();
                        console.error('SetSetPartDisList : ' + error);
                        setButtonEnable(true);
                    })

            } else {
                reject('data error');
            }
        });
    };

    /**
     * 画面遷移
     * @param param 
     * @returns 
     */
    const saveAction2 = (param: object): Promise<string> => {
        //console.debug(["--saveAction2 strat--"]);
        return new Promise((resolve, reject) => {
            const sp = param as SaveParameter;
            //console.debug(["--sp--", sp]);
            let editList = sp.list.filter((r) => r.isEdit === true);
            editList.forEach((r) => {
                if (r.DEV_INDEX == 0) {
                    r.RUN_FLG = undefined;
                    r.LOG_START = undefined;
                    r.ITM_NAME_NO = undefined;
                    r.LMT_L = undefined;
                    r.LMT_H = undefined;
                    r.MCLC_TYP_ID_MAX = undefined;
                    r.TYP_NO_MAX = undefined;
                    r.LMT_L_PD = undefined;
                    r.LMT_H_PD = undefined;
                    r.MCLC_TYP_ID_PD = undefined;
                    r.TYP_NO_PD = undefined;
                    r.IP_ADR = undefined;
                }
            });
            // console.debug(["--editList--", editList]);
            setButtonEnable(false);
            saveProc(editList)
                .then((r) => {
                    props.editData.IsUpdate = false;
                    console.debug('saveAction ok');
                    resolve('done');
                })
                .finally(() => {
                    setButtonEnable(true);
                });
        });
    };

    /**
     * 中止アクション
     */
    const cancelAction = () => {
        if (props.editData.IsUpdate) {
            setDlgmsg(
                t(
                    'PartialDischargeCollectionPage.保存していないデータを破棄します\nよろしいですか',
                    '保存していないデータを破棄します。\nよろしいですか?'
                )
            );
            actCfmDlg
                .open()
                .apply((_) => {
                    props.editData.IsUpdate = false;
                    updateData();
                    props.editData.UpdateCancel();
                })
                .cancel(() => { });
        }
    };

    return (
        <>
            <TableContainer
                component={Paper}
                className={pageStyle.tableContainer}
            >
                <Table stickyHeader aria-label="featureParamater">
                    <TableHead>
                        <TableRow>
                            <TableCell className={pageStyle.fixHeader} width={40}>No</TableCell>
                            <TableCell className={pageStyle.fixHeader} width={40}>{t('PartialDischargeCollectionPage.実行', '実行')}</TableCell>
                            <TableCell className={pageStyle.fixHeader} width={160}>{t('PartialDischargeCollectionPage.機器番号_名称', '機器番号・名称')}</TableCell>
                            {partialDischargeIpEnabled === true ?
                                <TableCell className={pageStyle.fixHeader} width={120}>{t('PartialDischargeCollectionPage.IPアドレス', 'IPアドレス')}</TableCell>
                                : null
                            }
                            <TableCell className={pageStyle.fixHeader} width={120}>{t('PartialDischargeCollectionPage.収集開始時刻', '収集開始時刻')}</TableCell>
                            <TableCell className={pageStyle.fixHeader} width={'160px'}>
                                <Table>
                                    <TableRow>
                                        <TableCell colSpan={2} className={pageStyle.fixHeader}>{t('PartialDischargeCollectionPage.部分放電判定_しきい値', '部分放電判定 しきい値[V]')}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className={pageStyle.fixHeader}>{t('PartialDischargeCollectionPage.軽故障', '軽故障')}</TableCell>
                                        <TableCell className={pageStyle.fixHeader}>{t('PartialDischargeCollectionPage.重故障', '重故障')}</TableCell>
                                    </TableRow>
                                </Table>
                            </TableCell>
                            <TableCell className={pageStyle.fixHeader} width={'160px'}>
                                <Table>
                                    <TableRow>
                                        <TableCell colSpan={2} className={pageStyle.fixHeader}>{t('PartialDischargeCollectionPage.部分放電判定_PD強度しきい値', '部分放電判定 PD強度しきい値[V]')}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className={pageStyle.fixHeader}>{t('PartialDischargeCollectionPage.軽故障', '軽故障')}</TableCell>
                                        <TableCell className={pageStyle.fixHeader}>{t('PartialDischargeCollectionPage.重故障', '重故障')}</TableCell>
                                    </TableRow>
                                </Table>
                            </TableCell>
                            <TableCell className={pageStyle.fixHeader} width={120}>{t('PartialDischargeCollectionPage.部分放電判定_最大値異常内容No', '部分放電判定\n最大値異常内容No')}</TableCell>
                            <TableCell className={pageStyle.fixHeader} width={120}>{t('PartialDischargeCollectionPage.部分放電判定_PD強度異常内容No', '部分放電判定\nPD強度異常内容No')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {setPartDisList.map((row, index) => {
                            return (
                                <PartialDischargeCollectionBody
                                    setPartDisItem={row}
                                    updateItem={changeSetPartDis}
                                    nameDevComboBoxItemList={nameDevSetComboBoxItemList}
                                    mclcTypIdMaxComboBoxItemList={mclcTypIdMaxComboBoxItemList}
                                    mclcTypIdPdComboBoxItemList={mclcTypIdPdComboBoxItemList}
                                    partialDischargeIpEnabled={partialDischargeIpEnabled}
                                />
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item xs={12}>
                <PartialDischargeCollectionFooter
                    onClickSaveButton={saveAction}
                    onClickCancelButton={cancelAction}
                    buttonEnable={buttonEnable}
                ></PartialDischargeCollectionFooter>
            </Grid>
            {cfmdlg}
            {msgdlg}
        </>
    )
}

export default PartialDischargeCollectionPage;